<h1>Benachrichtigungen ändern</h1>

<p>
  Hier können Sie einstellen, ob Sie bei neuen Verbrauchsdaten benachtigt werden möchten.
</p>

<div class="loading">
  <mat-spinner *ngIf="loading"></mat-spinner>
</div>

<div class="content" *ngIf="!loading && !errKey && !errFailure">
  <p>
    Möchten Sie Benachrichtigungen erhalten?
  </p>

  <div class="buttons">
    <button mat-raised-button class="yes" [class.inactive]="!state" (click)="switchState(true)">
      <mat-icon>notifications</mat-icon>
      Ja, Benachrichtigungen aktivieren
    </button>
    <button mat-raised-button class="no" [class.inactive]="state" (click)="switchState(false)">
      <mat-icon>notifications_off</mat-icon>
      Nein, Benachrichtigungen deaktivieren
    </button>
  </div>
</div>

<div class="errors">
  <div *ngIf="errKey">
    <mat-icon>link_off</mat-icon>
    Der Link ist nicht gültig.
  </div>
  <div *ngIf="errFailure">
    <mat-icon>close</mat-icon>
    Es ist ein Fehler aufgetreten.
  </div>
</div>

<div class="messages">
  <div *ngIf="msgSuccess">
    <mat-icon>done</mat-icon>
    Ihre Änderungen wurden gespeichert.
  </div>
</div>
